import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import './Login.css';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { clearAuthData } from '../../util/AuthUtils';

export default function Logout(): JSX.Element {
  const { logout } = useKindeAuth();

  useEffect(() => {
    const bailOnSession = async () => {
      clearAuthData();
      logout();
    };

    bailOnSession();
  }, [logout]);

  const [showLoading] = useState(true);

  return (
    <>
      <Backdrop open={showLoading} sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
        <CircularProgress sx={{ color: 'text.disabled' }} />
      </Backdrop>
      <Box display="flex" flex="1 0 0">
        <Box bgcolor="primary.main" flex="1 0 0">
          <Box display="flex" height="100%" justifyContent="center" alignItems="center"></Box>
        </Box>
      </Box>
    </>
  );
}
